"use strict";
/**
 * In-Memory Implementation of IPolicyRepository for development & testing.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryPolicyRepository = void 0;
class InMemoryPolicyRepository {
    _policies = new Map();
    save(policy) {
        this._policies.set(policy.id, policy);
    }
    getById(policyId) {
        return this._policies.get(policyId) || null;
    }
    listByCustomerId(customerId) {
        return Array.from(this._policies.values()).filter((policy) => policy.customer.id === customerId);
    }
}
exports.InMemoryPolicyRepository = InMemoryPolicyRepository;
